import { GdvFeatureGuard } from '@aid/gdv/guards/gdv-feature.guard';

export const guards = [GdvFeatureGuard];

export * from './gdv-feature.guard';
